import { useTheme } from "styled-components";
import EntityTranslationsContainer from "../../../components/entityTranslationsContainer/EntityTranslationsContainer";
import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import { useLanguageContext } from "../../../context/LanguageContext";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";

function ParkingLocationPageView({
  parkingLocationData,
  translationsController,
  onNameChange,
  onCapacityChange,
  onCapacityForVisitorsChange,
  onCancel,
  onSubmit,
  submitError,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <>
      <OverlayLoader groups="parking_location_page_fetch">
        <FormContainer
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"parking_location_page_submit"}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.name")}
              error={EVAApiHelper.getResponseError("name", submitError)}
              required
            >
              <StyledInput
                type="text"
                onChange={onNameChange}
                placeholder={translate("eva.main.validation.attributes.name")}
                value={parkingLocationData.name}
              />
            </InputWrapper>

            <StyledFlexRow>
              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.capacity")}
                  error={EVAApiHelper.getResponseError("capacity", submitError)}
                  required
                >
                  <StyledInput
                    type="number"
                    min={0}
                    onChange={onCapacityChange}
                    placeholder={translate(
                      "eva.main.validation.attributes.capacity"
                    )}
                    value={parkingLocationData.capacity}
                  />
                </InputWrapper>
              </StyledFlexItem>

              <StyledFlexItem>
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.capacity_for_visitors"
                  )}
                  error={EVAApiHelper.getResponseError(
                    "capacity_for_visitors",
                    submitError
                  )}
                  required
                >
                  <StyledInput
                    type="number"
                    min={0}
                    max={parkingLocationData.capacity}
                    onChange={onCapacityForVisitorsChange}
                    placeholder={translate(
                      "eva.main.validation.attributes.capacity_for_visitors"
                    )}
                    value={parkingLocationData.capacity_for_visitors}
                  />
                </InputWrapper>
              </StyledFlexItem>
            </StyledFlexRow>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <OverlayLoader groups="parking_location_page_fetch">
        <EntityTranslationsContainer
          controller={translationsController}
          style={{ marginTop: theme.spacing.large }}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.message")}
              error={translationsController.getTranslationError(
                "message",
                submitError
              )}
            >
              <StyledInput
                as="textarea"
                value={translationsController.getValue("message")}
                onChange={(e) =>
                  translationsController.onTranslationChange(
                    e.target.value,
                    "message"
                  )
                }
              />
            </InputWrapper>
          </StyledFlexColumn>
        </EntityTranslationsContainer>
      </OverlayLoader>
    </>
  );
}

export default ParkingLocationPageView;
